module.exports = __webpack_public_path__ + "static/media/2-en.0fddec9c.svg";